import {
  Paper,
  Box,
  Typography,
  ThemeProvider,
  useTheme,
  IconButton,
  Table, TableBody, TableCell, TableContainer, TableRow
} from "@mui/material";
import * as React from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { Edit } from "@mui/icons-material";
import SimpleCollapse from "../../../component/MuiReusableComponents/MuiCollapse/collapseMUI";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useNavigate, useLocation } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
import MyButton from "../../../component/MuiReusableComponents/MuiButton/buttonMUI";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import { useForm, FormProvider } from "react-hook-form";
import FormHead from "../../../component/MuiReusableComponents/FormHeadText/formHeadText";
import MyTextField from "../../../component/MuiReusableComponents/MuiFormComponents/TextField.Component";
import { matchIsValidTel } from "mui-tel-input";
import PopupDialogs from "../../../component/MuiReusableComponents/MuiPopupDialog/new-popup";
import DeletePopup from "../../../component/DeletePopup/deletePopup";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import {
  loaderMessageSelector,
  startFilterData,
  FilterDataSelector
} from "../../../store1/client data/client.data.slice.selector";
import FilterAndAddBar from "../../../component/ModulesAddAndFilter/moduleAddAndFilter";
import { readStringDate } from "../../../function utils/functionUtils";
import { usersDataSelector } from "../../../store1/user login data/user.login.data.slice.slector";
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import { startAddRestoreVendor, startDeleteVendor, startFilterVendorsData, startSingleVendorData, startVendorsDataByPageIndex, vendorListDataWithPageSelector } from "../../../store1/vendor data/vendor.data.slice.selector";
import VendorTable from "./customVendorTable";
import { PERMISSIONS } from "../../../routes/permissionsCode";
import { hasPermission } from "../../../store1/user login data/user.login.data.slice.slector";

//////Needed Component
const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "S No.",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Vendor Name",
  },
  {
    id: "phone",
    numeric: false,
    disablePadding: false,
    label: "Office Phone No",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Office Email Id",
  },
  {
    id: "address_line_one",
    numeric: false,
    disablePadding: false,
    label: "Address",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
    align: "center"
  },
];

////Needed Component
const FilterAndSearchBox = ({ infoData }) => {
  const {
    setCollapseFilterControl,
    filterStatus,
    setFilterStatus,
    setFilteredRows,
    rows,
  } = infoData;
  const dispatch = useDispatch()
  ////Date

  React.useEffect(() => {
    if (!filterStatus) {
      form.reset({
        startDateValue: new Date("2012-08-18T21:11:54"),
        endDateValue: new Date(),
        personName: [],
      });
    }
  }, [filterStatus]);
  const form = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      clientName: "",
      officeEmailId: "",
      officePhone: "",
    },
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const onSubmit = (data) => {
    setIsSubmitting(true)
    const mappedData = {
      pageSize: 10,
      pageIndex: 1,
      vendorName: data.clientName,
      email: data.officeEmailId,
      contactNumber: data.officePhone
    };
    // code for filter will be here
    dispatch(startFilterVendorsData(mappedData))
    dispatch(startFilterData(mappedData))
    setIsSubmitting(false)

  };

  const [isNumberValid, setNumberValid] = React.useState(false);
  return (
    <Paper
      sx={{ borderRadius: "10px", marginBottom: "15px", bgcolor: "#dff9fb87" }}
    >
      <Box
        sx={{
          textAlign: "right",
          width: "100%",
          paddingTop: "10px",
          bgcolor: "#ffeaa7b3",
        }}
      >
        <Typography
          sx={{
            width: "100%",
            textAlign: "left",
            fontWeight: "bold",
            paddingLeft: "15px",
          }}
          variant="subtitle1"
          gutterBottom
        >
          Filter
        </Typography>
      </Box>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Box
            sx={{
              width: "100%",
              padding: "15px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: "1",
                padding: "0px 15px",
              }}
            >
              <FormHead headText="Vendor Name" />
              <MyTextField
                size="small"
                type="text"
                name="clientName"
                placeholder="Enter Vendor Name"
                sx={{
                  width: "99%",
                }}

              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                paddingRight: "15px",
              }}
            >
              <FormHead headText="Office Phone No" />

              <MyTextField
                size="small"
                type="number"
                placeholder="Enter Contact Number"
                sx={{
                  width: "94%",
                }}
                name="officePhone"

              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <FormHead headText="Office Email Id" />
              <MyTextField
                size="small"
                type="text"
                name="officeEmailId"
                placeholder="Enter Office Email"
                sx={{
                  width: "93%",
                }}

              />
            </Box>
          </Box>
          <Box
            sx={{ width: "100%", textAlign: "center", paddingBottom: "10px" }}
          >
            <MyButton
              size="small"
              sx={{ marginRight: "15px" }}
              variant="contained"
              type="submit"
              startIcon={<SearchIcon />}
              disabled={isSubmitting}
            >
              Search
            </MyButton>
            <MyButton
              sx={{ marginRight: "15px" }}
              onClick={() => {
                setFilterStatus(false);
                setFilteredRows(rows);
                form.reset()
                dispatch(startFilterData({
                  pageSize: 10,
                  pageIndex: 1,
                  clientName: "",
                  officeEmailId: "",
                  officePhone: ""
                }))
                dispatch(startVendorsDataByPageIndex({
                  pageSize: 10,
                  pageIndex: 1,
                }))
              }}
              size="small"
              color="error"
              variant="contained"
            >
              Reset
            </MyButton>
            <MyButton
              variant="outlined"
              size="small"
              onClick={() => setCollapseFilterControl(false)}
              startIcon={<CancelPresentationIcon color="error" />}
            >
              Close
            </MyButton>
          </Box>
        </form>
      </FormProvider>
    </Paper>
  );
};
//Restore Component popup
const ClientReasonForm = ({ row, setPopUpBool, pageIndex, pageSize }) => {
  const dispatch = useDispatch();
  const [remarkReason, setRemarkReason] = React.useState("");

  const userLoginData = useSelector(usersDataSelector);


  const reasonChangeHandler = (event) => {
    setRemarkReason(event.target.value);
  };

  const onSubmitHandler = () => {
    if (remarkReason.trim() === '') {
      return;
    }
    setPopUpBool();
    dispatch(
      startAddRestoreVendor({
        changeRemarkData: {
          type_id: row?.id,
          type: "Vendor",
          user_name: userLoginData.userName,
          user_email: userLoginData.userEmail,
          remarks: remarkReason,
          previous_data: JSON.stringify(row),
        },
        tableData: { pageIndex: Number(pageIndex) + 1, pageSize },
        updateData: {
          id: row?.id,
          name: row?.name,
          pan: row?.pan,
          phone: row?.phone,
          contact_name: row?.contact_name,
          phone: row?.phone,
          credit_term: row?.credit_term,
          email: row?.email,
          gstin_no: row?.gstin_no,
          country: row.country,
          remarks: row?.remarks,
          currency: row?.currency,
          short_name: row.short_name,
          status: 1,
          address_line_one: row?.address_line_one,
          address_line_two: row?.address_line_two,
          state: row?.state,
          city: row?.city,
          zip: row?.zip,
          url: "vendors/add",
        },
      }),

    );
  };

  return (
    <>
      <Box>
        <Grid container sx={{ p: "10px" }} columnSpacing={1}>
          <Grid item xs={12}>
            <TableContainer sx={{ marginBottom: "17px" }}>
              <Table>
                <TableBody>
                  <TableRow sx={{
                    borderTop: "2px solid black",
                    borderLeft: "2px solid black",
                    borderRight: "2px solid black",
                  }}>
                    <TableCell sx={{ borderRight: "2px solid black", padding: "5px" }}>Current Date:</TableCell>
                    <TableCell sx={{ padding: "5px" }}>{readStringDate(new Date().toDateString())}</TableCell>
                  </TableRow>
                  <TableRow sx={{
                    marginBottom: "10px",
                    border: "2px solid black"
                  }}>
                    <TableCell sx={{ borderRight: "2px solid black", padding: "5px" }}>User Name:</TableCell>
                    <TableCell sx={{ padding: "5px" }}>{userLoginData.userName}</TableCell>
                  </TableRow>
                  <TableRow sx={{
                    marginBottom: "10px",
                    border: "2px solid black"
                  }}>
                    <TableCell sx={{ borderRight: "2px solid black", padding: "5px" }}>User Email:</TableCell>
                    <TableCell sx={{ padding: "5px" }}>{userLoginData.userEmail}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Divider sx={{ marginY: "20px" }} />

            <Grid item xs={12} sm={12}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}>
                <FormHead
                  sx={{ whiteSpace: "nowrap", paddingTop: "15px", color: "black" }}
                  headText={`Reason `}
                  required={true}
                />

                <TextField
                  onChange={reasonChangeHandler}
                  value={remarkReason}
                  placeholder="Reason is required"
                  multiline={true}
                  rows={3}
                  fullWidth // Takes full width
                  sx={{ marginTop: "5px" }} // Adjust top margin as needed                 
                />
              </Box>
            </Grid>

            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Box sx={{ marginTop: "15px", display: "flex", gap: "10px" }}>
                <MyButton
                  type="submit"
                  startIcon={<WarningAmberIcon color="error" />}
                  size="small"
                  variant="contained"
                  color="success"
                  onClick={onSubmitHandler}
                  sx={{ width: "100%" }}
                  disabled={remarkReason.trim() === '' || remarkReason.length < 5}
                >
                  Confirm
                </MyButton>
                <MyButton
                  type="close"
                  startIcon={< CloseIcon color="error" />}
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={setPopUpBool}
                  sx={{ width: "100%" }}
                >
                  Close
                </MyButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
//Action Column with all 3 icons
const ActionColumn = ({
  row,
  onClickView,
  onClickEdit,
  pageIndex,
  pageSize,
}) => {
  const pathName = useLocation().pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [popUpOpen, setPopUpOpen] = React.useState(false);
  const [popupOpen2, setPopUpOpen2] = React.useState(false);
  const canEditVendor = useSelector((state) => hasPermission(state, PERMISSIONS.FINANCE.INVOICE.VENDOR_EDIT));
  const canViewVendorDetails = useSelector((state) => hasPermission(state, PERMISSIONS.FINANCE.INVOICE.VENDOR_DETAILS));


  function setClosePopup() { //to close popup
    setPopUpOpen2(false);
    setPopUpOpen(false);
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
      }}
    >
      <IconButton
        disabled={!canViewVendorDetails}
        onClick={() => navigate(`${pathName}/${row.id}/vendor-details`)}
        title="View Vendor Report"
        size="small"
      >
        <VisibilityOutlinedIcon color="primary" />
      </IconButton>

      {Boolean(row.status) ? (
        <IconButton
          disabled={!canEditVendor}
          onClick={() => {
            dispatch(startSingleVendorData(row.id));
            navigate(`${pathName}/${row.id}/edit`);
          }}
          color="primary"
          title="Edit Details"
          size="small"
        >
          <Edit />
        </IconButton>) : (
        <IconButton
          title="Restore Vendor"
          aria-label="delete"
          onClick={() => {
            setPopUpOpen2(true);
          }}
        >
          <SettingsBackupRestoreIcon color="error" />
        </IconButton>
      )
      }
      {
        Boolean(row.status) ? (
          <IconButton
            title="Delete Vendor"
            aria-label="delete"
            onClick={() => {
              setPopUpOpen(true);
            }}
          >
            <DeleteIcon color="error" />
          </IconButton>
        ) : (
          <IconButton disabled title="Disabled" size="small">
            <DeleteIcon />
          </IconButton>
        )
      }
      <PopupDialogs
        title={`Delete Vendor`}
        needTitleBar={false}
        size="sm"
        open={popUpOpen}
        setOpen={setClosePopup}
      >
        {popUpOpen && <DeletePopup
          onClickNo={() => setPopUpOpen(false)}
          onClickYes={() => {
            dispatch(
              startDeleteVendor({
                data: row.id,
                tableData: { pageIndex: Number(pageIndex) + 1, pageSize },
              })
            );
          }}
        />}
        
      </PopupDialogs>
      <PopupDialogs
        title={`Restore Client ${row.name}`}
        needTitleBar={true}
        size="sm"
        open={popupOpen2}
        setOpen={setClosePopup}
      >
        {popupOpen2 && (
          <ClientReasonForm      //to reverse finalised invoice
            row={row}
            setPopUpBool={setClosePopup}
            pageIndex={pageIndex}
            pageSize={pageSize}
          />
        )}
      </PopupDialogs>
    </Box>
  );
};
/////////Main Component
const VendorsList = ({
  isLoading,                    // props from clientsParentRoute
  pageIndex,
  pageSize,
  setPageIndex,
  setPageSize,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const locationName = useLocation().pathname;
  ///
  const [collapseFilterControl, setCollapseFilterControl] =
    React.useState(false);
  const clientsData = useSelector(vendorListDataWithPageSelector);
  const fildata = useSelector(FilterDataSelector)
  const [filterStatus, setFilterStatus] = React.useState(false);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const loadingMessage = useSelector(loaderMessageSelector);
  const [data, setData] = React.useState([]);
  
  ///
  React.useEffect(() => {
    setFilteredRows(clientsData);
  }, [clientsData, data]);
  ///
  const onclickFilter = () => setCollapseFilterControl(!collapseFilterControl);
  const onClickAdd = () => navigate("/manage-accounts/vendors-list/add-vendor");
  const canCreateVendor = useSelector((state) => hasPermission(state, PERMISSIONS.FINANCE.INVOICE.VENDOR_ADD));
  
  const [rowsCount, setRowsCount] = React.useState(0);
  ///
  const fecthDataDispatch = () => {
    if (fildata.vendorName || fildata.email || fildata.contactNumber) {
      const mapobj = {
        vendorName: fildata.vendorName,
        email: fildata.email,
        contactNumber: fildata.contactNumber
      };
      dispatch(startFilterVendorsData(mapobj));
    } else {
      dispatch(startVendorsDataByPageIndex());
    }
  }

  ///
  React.useEffect(() => {
    if (clientsData && clientsData.length > 0) {
      setFilteredRows(clientsData[0]);
      setData(clientsData[0]);
      setRowsCount(clientsData[1][0].total_count);
    }
  }, [clientsData]);
  React.useEffect(() => {
    if (data?.length === 0) {
      dispatch(
        startVendorsDataByPageIndex({
          pageSize,
          pageIndex: pageIndex + 1,
        })
      );
    }
  }, [pageIndex, pageSize]);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <FilterAndAddBar
          onclickFilter={onclickFilter}
          onClickAdd={onClickAdd}
          filterStatus={filterStatus}
          setCollapseFilterControl={setCollapseFilterControl}
          collapseFilterControl={collapseFilterControl}
          filterName=" Filter"
          AddButtonName=" + Add New Vendor"
          showAddButton={canCreateVendor}
        />

        <SimpleCollapse
          infoData={{
            setCollapseFilterControl,
            filterStatus,
            setFilterStatus,
            setFilteredRows,
            rows: clientsData,
          }}
          control={collapseFilterControl}
          CollapseComponent={FilterAndSearchBox}
        />

        <VendorTable
          headCells={headCells}
          isLoading={isLoading}
          loadingMessage={loadingMessage}
          ActionComponent={ActionColumn}
          data={data}
          dispatchAPI={fecthDataDispatch}
          rowsCount={rowsCount}
          setRowsCount={setRowsCount}
          pathName={locationName}
          pageSize={pageSize}
          pageIndex={pageIndex}
          setPageSize={setPageSize}
          setPageIndex={setPageIndex}
        />

      </Box>
    </ThemeProvider>
  );
};
export default VendorsList;